module.exports = new __parcel__URL__("need-for-speed-high-stakes.36678b9e.jpg").toString();